import { Box, Text } from '@betty/moonlight';
import { SessionHistoryListItemRowProps } from './SessionHistoryListItemRow.types';
import { memo } from 'react';

function SessionHistoryListItemRow({
  labelKey,
  valueA,
  valueAColor,
  valueB,
  accent,
}: SessionHistoryListItemRowProps) {
  return (
    <Box flexDirection="row">
      <Box width="50%">
        <Text
          locNS="account"
          locKey={labelKey}
          variant={accent ? 'body-m-semi' : 'body-m'}
          color={accent ? 'darkSurfacePrimary' : 'darkSurfaceMuted'}
        />
      </Box>
      <Box width="50%" flexDirection="row" justifyContent="space-between">
        <Text
          variant={accent ? 'body-m-semi' : 'body-m'}
          color={valueAColor || 'darkSurfacePrimary'}
        >
          {valueA}
        </Text>
        <Text variant="body-m" color="darkSurfacePrimary">
          {valueB}
        </Text>
      </Box>
    </Box>
  );
}

export default memo(SessionHistoryListItemRow);
